import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {submitCity, updateCity} from "../../../services/city/city";
import {getProvinces} from "../../../services/province/province";

export function CityForm({city, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setId(city?.id ?? null);
    setTitle(city?.title ?? "");
    setDescription(city?.description ?? "");
    setProvinceId(city?.province_id ?? "");
    setOrderBy(city?.order_by ?? "");
    setStatus(city?.status === 'enable' ?? false);
  }, [city]);


  const save = async () => {
    const data = {
      id: id,
      title: title,
      description: description,
      province_id: parseInt(provinceId),
      order_by: parseInt(orderBy),
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitCity(data);
    } else {
      result = await updateCity(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={title}
                   label={Dict('title')}
                   placeholder={Dict('title')}
                   onChange={(e) => {
                     setTitle(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={description}
                   label={Dict('description')}
                   placeholder={Dict('description')}
                   onChange={(e) => {
                     setDescription(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <SelectInput
              label="استان"
              defaultValue={provinceId}
              autoLoadService={getProvinces}
              onChange={setProvinceId}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={orderBy}
                   label={Dict('order_by')}
                   placeholder={Dict('order_by')}
                   type="number"
                   min="0"
                   onChange={(e) => {
                     setOrderBy(e.target.value)
                   }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}